export default __webpack_public_path__ + "static/media/woman-smiling.da24eb3a.jpg";